module.exports = __webpack_public_path__ + "img/image9.6389228b.png";